import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import ForgotPassword from "./Components/ForgotPassword";
import LoginPage from "./Components/LoginPage";
import AdminPage from "./Components/AdminPage";
import Layout from "./Components/Layout";
import Users from "./Components/Users";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UseResendCode from "./Components/UseResendCode";
import Data from "./Components/Data";
import RuleForm from "./Components/RuleForm";
import Rules from "./Components/Rules";
import Alerts from "./Components/Alerts";
import AlertModal from "./Components/AlertModal";
import InboundMonitoring from "./Components/InboundMonitoring";
import GatewayConfigs from "./Components/GatewayConfigs";

function App() {
  const router = createBrowserRouter(
    [
      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        path: "/forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "/reset-password",
        element: <UseResendCode />,
      },
      {
        path: "/",
        element: <Layout />,
        children: [
          { index: true, element: <Navigate to="/alerts" /> },
          {
            path: "admin",
            element: <AdminPage />,
          },
          {
            path: "users",
            element: <Users />,
          },
          {
            path: "data",
            element: <Data />,
          },
          {
            path: "rules/:ruleID",
            element: <RuleForm />,
          },
          {
            path: "rules",
            element: <Rules />,
          },
          {
            path: "alerts",
            element: <Alerts />,
            children: [
              {
                path: ":alertId",
                element: <AlertModal />,
              },
            ],
          },
          {
            path: "inbound-monitoring",
            element: <InboundMonitoring />,
          },
          {
            path: "gateway-configs",
            element: <GatewayConfigs />,
          },
        ],
      },
    ],
    { basename: "/app" }
  );

  return (
    <div className="App">
      <RouterProvider router={router} />
      <ToastContainer />
    </div>
  );
}

export default App;
